import React, { Component } from 'react';
import {Link} from 'react-router-dom';




class NoticeList extends Component {

   constructor(props) {
    super(props);

  

     this.state={
     }
  }

  

  render() {
    const _this=this;

    var styles = {
        padding:'10px',
        marginBottom: '4px',
        marginTop: '4px'
      };

    return (


        <div className = "row col-lg-12 col-sm-12 col-sm-12">
            <div className="card" style ={styles}>
                <p className = "notice-header">{_this.props.an_details.title}</p>
                <p classname="notice-content">T{_this.props.an_details.content}</p>
            </div>
        </div>

                           

                            

                          
                     
      


    );
  }




}

export default NoticeList;
